export const REDUCER_NAME='instagramAccountSlice'

export interface iInstagramAccountDTO {
    // vendorId: string;
    fbuserId: string;
    fbpageId: string;
    fbAccountId: string;
    fbbusinessId: string;
    instaAccountId: string;
    tokenExpiresAt: Date;
    status?: string;
    accessToken?: string;
}

export interface iInstagramAccountState {
    isLoading: boolean; 
    instagramAccountList: iInstagramAccountDTO[]; 
    errorMessage: string | null; 
  }
  